import {
  ArrowUpRight,
  BarChart3,
  Database,
  LineChart,
  Zap,
} from 'lucide-react';

const outcomes = [
  {
    icon: Zap,
    title: 'Run Efficient Campaigns',
    desc: 'Optimize campaigns to reduce wasted ad spend and boost efficiency with smarter targeting.',
  },
  {
    icon: Database,
    title: 'Integrate Data Sources',
    desc: 'Access all your marketing data in one platform, simplifying insights from multiple sources.',
  },
  {
    icon: LineChart,
    title: 'Data-Driven Decisions',
    desc: 'Make confident, data-backed ad placement decisions across various POCs.',
  },
  {
    icon: BarChart3,
    title: 'Performance Tracking',
    desc: "Monitor every campaign's impact with multiple KPIs, ensuring timely strategy adjustments for success.",
  },
];

export default function OutcomeTiles() {
  return (
    <section className="landing-section">
      <div className="landing-section-head">
        <h2 className="section-title">Expected Outcomes</h2>
        <p className="section-subtitle">
          Discover a smarter approach to campaign management. Our platform equips you with
          powerful tools, from strategic planning to post campaign analysis.
        </p>
      </div>

      <div className="landing-tiles-grid landing-tiles-grid--four">
        {outcomes.map(({ icon: Icon, title, desc }) => (
          <article key={title} className="landing-tile">
            <div className="landing-tile-top">
              <span className="landing-tile-icon">
                <Icon size={24} strokeWidth={1.6} />
              </span>
              <ArrowUpRight className="landing-tile-arrow" size={18} strokeWidth={1.6} />
            </div>
            <h3 className="landing-tile-title">{title}</h3>
            <p className="landing-tile-desc">{desc}</p>
          </article>
        ))}
      </div>
    </section>
  );
}
